import PropTypes from 'prop-types'
import { Navigate } from 'react-router-dom'
import { MFA_SETUP_PATH, needsMfaSetup } from '@/features/allauth/lib/mfaPolicy'
import useAuth from '@/hooks/useAuth'

/**
 * Sends an administrator who signed in with a password, and has no
 * authenticator app yet, to set one up before the dashboard renders.
 *
 * The backend is the control: it refuses their API calls with
 * `code: "mfa_setup_required"` (userprofile/mfa_policy.py). This guard only
 * saves them a screen of failed requests by routing on the session payload's
 * `user.mfa.setupRequired`.
 */
const MfaSetupGuard = ({ children }) => {
    const { user } = useAuth()

    if (needsMfaSetup(user)) {
        return <Navigate to={MFA_SETUP_PATH} replace />
    }

    return <>{children}</>
}

MfaSetupGuard.propTypes = {
    children: PropTypes.node
}

export default MfaSetupGuard
